import { z } from 'zod'

const nonZeroSchema = z
  .string({ required_error: 'Text input is required' })
  .regex(/^\d*\.?\d*$/, 'Must be a valid number')
  .refine((value) => parseFloat(value) > 0, 'Must be greater than 0')

export const plantDetailFormSchema = z.object({
  image: z.any().optional(),
  reimbursement: nonZeroSchema,
  co2: nonZeroSchema,
  isActive: z.boolean().optional(),
})

export type PlantDetailFormType = z.infer<typeof plantDetailFormSchema>
